import type { Campaign } from '../contexts/CampaignsContext'

// Mock campaign data
export const mockCampaigns: Campaign[] = [
  {
    id: 'camp1',
    brand: {
      name: 'SportFuel',
      logo: 'https://placehold.co/200x200/1A73E8/FFFFFF/png?text=SF',
    },
    title: 'Energy Drink Summer Campaign',
    platform: 'TikTok',
    payout: 1500,
    status: 'live',
    startDate: '2025-05-01',
    endDate: '2025-05-31',
    brief: 'Showcase how SportFuel helps you train harder and recover faster',
    script:
      'SportFuel gives me the energy I need to push through tough workouts and recover faster. With its advanced formula, I can train harder than ever before.',
    audioUrl: 'https://example.com/sportfuel-audio.mp3',
    instructions:
      'Create a 15-30 second post showing you using SportFuel before or after training. Include the provided audio overlay.',
    postLink: 'https://tiktok.com/@user/video/123456',
    submittedAt: '2025-05-10',
    approvedAt: '2025-05-11',
    metrics: {
      views: 45000,
      engagement: 7.8,
      completionRate: 82,
    },
    paymentStatus: 'pending',
    notificationShown: true,
    dueDateNotificationShown: true,
  },
  {
    id: 'camp2',
    brand: {
      name: 'FitGear',
      logo: 'https://placehold.co/200x200/FF5722/FFFFFF/png?text=FG',
    },
    title: 'New Training Collection',
    platform: 'Instagram Reels',
    payout: 2000,
    status: 'live',
    startDate: '2025-05-14',
    endDate: '2025-06-14',
    brief: 'Showcase our new training collection in a workout routine',
    script:
      "I've upgraded my training with FitGear's new collection. The moisture-wicking technology keeps me dry, while the flexible fabric allows for maximum range of motion.",
    audioUrl: 'https://example.com/fitgear-audio.mp3',
    instructions:
      'Create a workout routine wearing our new training collection. Include the provided audio as a voiceover.',
    postLink: 'https://instagram.com/@user/video/789012',
    submittedAt: '2025-05-17',
    approvedAt: '2025-05-18',
    metrics: {
      views: 32000,
      engagement: 6.9,
      completionRate: 78,
    },
    notificationShown: true,
    dueDateNotificationShown: false,
  },
  {
    id: 'camp3',
    brand: {
      name: 'RecoveryPlus',
      logo: 'https://placehold.co/200x200/00C853/FFFFFF/png?text=R+',
    },
    title: 'Recovery Product Line',
    platform: 'YouTube Shorts',
    payout: 2500,
    status: 'pending',
    startDate: '2025-04-01',
    endDate: '2025-04-30',
    brief: 'Show your recovery routine using RecoveryPlus products',
    script:
      'RecoveryPlus has revolutionized my post-workout routine. Their massage gun, compression sleeves, and recovery supplements have cut my recovery time in half.',
    audioUrl: 'https://example.com/recoveryplus-audio.mp3',
    instructions:
      'Film your post-workout recovery routine featuring RecoveryPlus products. Include the provided audio.',
    postLink: 'https://youtube.com/shorts/abcdef',
    submittedAt: '2025-04-10',
    approvedAt: '2025-04-12',
    metrics: {
      views: 78000,
      engagement: 9.2,
      completionRate: 87,
    },
    paymentStatus: 'paid',
    paymentDate: '2025-05-03',
    notificationShown: true,
    dueDateNotificationShown: true,
  },
  {
    id: 'bid1',
    brand: {
      name: 'PowerBar',
      logo: 'https://placehold.co/200x200/9C27B0/FFFFFF/png?text=PB',
    },
    title: 'Protein Bar Campaign',
    platform: 'TikTok',
    payout: 1800,
    status: 'bid',
    startDate: '2025-06-01',
    endDate: '2025-06-30',
    brief: 'Show how PowerBar protein bars fit into your training regimen',
    script:
      "I fuel my workouts with PowerBar protein bars. With 20g of protein and only 1g of sugar, they're the perfect pre-workout snack or post-workout recovery.",
    audioUrl: 'https://example.com/powerbar-audio.mp3',
    instructions:
      'Create a TikTok showing how you incorporate PowerBar into your training routine. Include the provided audio.',
  },
  {
    id: 'bid2',
    brand: {
      name: 'HydroX',
      logo: 'https://placehold.co/200x200/03A9F4/FFFFFF/png?text=HX',
    },
    title: 'Hydration Campaign',
    platform: 'Instagram Reels',
    payout: 1600,
    status: 'bid',
    startDate: '2025-06-15',
    endDate: '2025-07-15',
    brief: 'Showcase how HydroX keeps you hydrated during intense training',
    script:
      "HydroX electrolyte drink keeps me hydrated during my most intense workouts. With essential minerals and zero artificial ingredients, it's hydration done right.",
    audioUrl: 'https://example.com/hydrox-audio.mp3',
    instructions:
      'Create a Reel showing you using HydroX during a training session. Include the provided audio.',
  },
  {
    id: 'camp4',
    brand: {
      name: 'AthleticWear',
      logo: 'https://placehold.co/200x200/E91E63/FFFFFF/png?text=AW',
    },
    title: 'Spring Training Gear',
    platform: 'TikTok',
    payout: 1750,
    status: 'pending',
    startDate: '2025-05-20',
    endDate: '2025-06-20',
    brief: 'Showcase our new spring training gear in your workout routine',
    script:
      "This spring, I'm training in AthleticWear's latest collection. The breathable fabric and ergonomic design make every workout feel effortless.",
    audioUrl: 'https://example.com/athleticwear-audio.mp3',
    instructions:
      'Create a 15-30 second TikTok showing you training in our spring collection. Include the provided audio overlay.',
    notificationShown: true,
    dueDateNotificationShown: false,
    conceptStatus: 'approved',
  },
]

// Update the bid objects to include timestamp
mockCampaigns.forEach((campaign) => {
  if (campaign.status === 'bid') {
    campaign.bidReceivedAt = new Date().toISOString()
    campaign.notificationShown = false
  }
})
